export const CREATE_REPAIR_HISTORY = "CREATE_REPAIR_HISTORY";
export const FETCH_REPAIR_HISTORIES = "FETCH_REPAIR_HISTORIES";
export const FETCH_REPAIR_HISTORY = "FETCH_REPAIR_HISTORY";
export const EDIT_REPAIR_HISTORY = "EDIT_REPAIR_HISTORY";
export const DELETE_REPAIR_HISTORY = "DELETE_REPAIR_HISTORY";
